import Vue from 'vue'
import Vuex from 'vuex'

//Default application level store modules
import appSettings from "@/_store/modules/app-settings"
import userSettings from "@/_store/modules/user-settings"
import credentials from "@/_store/modules/credentials"
import storeSegmentDetail from './modules/store-segment-detail'
import userDetails from './modules/user-details'

//App Level store modules.
import registration from "@/registration"
const storeRegistrations = registration.filter(e => typeof(e.store) == typeof({})).map(e => e.store)

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    appSettings,
    userSettings,
    credentials,
    storeSegmentDetail,
    userDetails,
    ...storeRegistrations
  }
})
